var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.25C2.0335 1.25 1.25 2.0335 1.25 3V11C1.25 11.9665 2.0335 12.75 3 12.75H9C9.9665 12.75 10.75 11.9665 10.75 11V3C10.75 2.0335 9.9665 1.25 9 1.25H3ZM2.75 3C2.75 2.86193 2.86193 2.75 3 2.75H9C9.13807 2.75 9.25 2.86193 9.25 3V11C9.25 11.1381 9.13807 11.25 9 11.25H3C2.86193 11.25 2.75 11.1381 2.75 11V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.25C2.0335 15.25 1.25 16.0335 1.25 17V21C1.25 21.9665 2.0335 22.75 3 22.75H9C9.9665 22.75 10.75 21.9665 10.75 21V17C10.75 16.0335 9.9665 15.25 9 15.25H3ZM2.75 17C2.75 16.8619 2.86193 16.75 3 16.75H9C9.13807 16.75 9.25 16.8619 9.25 17V21C9.25 21.1381 9.13807 21.25 9 21.25H3C2.86193 21.25 2.75 21.1381 2.75 21V17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 13C13.25 12.0335 14.0335 11.25 15 11.25H21C21.9665 11.25 22.75 12.0335 22.75 13V21C22.75 21.9665 21.9665 22.75 21 22.75H15C14.0335 22.75 13.25 21.9665 13.25 21V13ZM15 12.75C14.8619 12.75 14.75 12.8619 14.75 13V21C14.75 21.1381 14.8619 21.25 15 21.25H21C21.1381 21.25 21.25 21.1381 21.25 21V13C21.25 12.8619 21.1381 12.75 21 12.75H15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.25C14.0335 1.25 13.25 2.0335 13.25 3V7C13.25 7.9665 14.0335 8.75 15 8.75H21C21.9665 8.75 22.75 7.9665 22.75 7V3C22.75 2.0335 21.9665 1.25 21 1.25H15ZM14.75 3C14.75 2.86193 14.8619 2.75 15 2.75H21C21.1381 2.75 21.25 2.86193 21.25 3V7C21.25 7.13807 21.1381 7.25 21 7.25H15C14.8619 7.25 14.75 7.13807 14.75 7V3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.67dd3b77d20149a7d3b5e3908f088e95.svg";
export { ForwardRef as ReactComponent };